import React, { useEffect, useState } from "react";
import Step from "../../Components/Stepper/Step";
import BasicInformation from "../../Components/Stepper/Steps/BasicInformation";
import Profession from "../../Components/Stepper/Steps/Profession";
import Religion from "../../Components/Stepper/Steps/Religion";
import Photo from "../../Components/Stepper/Steps/Photo";
import Expectation from "../../Components/Stepper/Steps/Expectation";
import Complete from "../../Components/Stepper/Steps/Complete";
import UserQuestionnaire from "../../Components/Stepper/Steps/QuestionnariePage";
import { useLocation } from "react-router-dom";
import MessageBar, {
  config,
  errorNotify,
  getValueFromLocalStorage,
  localStorageKey,
  successNotify,
  updateValueInLocalStorage,
} from "../../utils/helper";
import configuration from "../../Config/configuration";
import { authorizedGet, authorizedPost } from "../../Config/networkWithToken";
import QuestionnaireForm from "../../Components/Stepper/Steps/QuestionnaireForm";

const EditProfile = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const location = useLocation();
  const [userDetails, setUserDetails] = useState({});
  const [userRole, setUserRole] = useState("");
  const [loading, setLoading] = useState(false);
  const [profileCompletionPercentage, setProfileCompletionPercentage] =
    useState(0);
  const [isClicked, setIsClicked] = useState();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");

  const userData = getValueFromLocalStorage(
    localStorageKey.USERDATA,
    "profile",
  );
  // const questionnaireCheckvalue = userData?.questionnaire?.isQuestionnaireForm;
  const questioonaireLink = userData
    ? userData?.questionnaire?.questionLink
    : userDetails?.profile?.questionnaire?.questionLink;

  const [questionnaireCheck, setQuestionnaireCheck] = useState(
    questioonaireLink || false,
  );

  const steps = [
    "Basic information",
    "Profession",
    "Religion & Family",
    "Photo",
    "Expectations",
    "Questionnaire",
    "Complete",
  ];

  const percentageMapping = [
    { percentage: 0, step: 1 },
    { percentage: 12.5, step: 2 },
    { percentage: 25.0, step: 3 },
    { percentage: 62.5, step: 4 },
    { percentage: 75.0, step: 5 },
    { percentage: 87.5, step: 6 },
    { percentage: 100.0, step: 1 },
  ];

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const profileCompletionPercentage =
      userData?.profileCompletionPercentage || 0;
    const step =
      percentageMapping.find(
        (item) => profileCompletionPercentage <= item.percentage,
      )?.step || 1;
    const role = userData?.role;
    setProfileCompletionPercentage(profileCompletionPercentage);
    if (role) {
      setUserRole(role);
    }

    setCurrentStep(step);
    if (role === "user") {
      if (!userData?.isActive || profileCompletionPercentage < 100) {
        successNotify("Kindly complete your profile to continue.");
      }
    }
    if (role === "admin" || role === "superAdmin") {
      fetchSingleUser();
    }
  }, [location.state]);

  useEffect(() => {
    if (
      currentStep === 6 &&
      questioonaireLink &&
      userRole !== "admin" &&
      userRole !== "superAdmin"
    ) {
      setCurrentStep(7); 
    }
    if (currentStep === 6) {
      setIsPopupOpen(true);
    }
    window.scrollTo(0, 0);
  }, [currentStep,questioonaireLink,userRole]);

  const handleSubmit = async () => {
    setIsPopupOpen(false);
    try {
      const data = {
        questionnaire: {
          isQuestionnaireForm: selectedOption === "form" ? true : false,
        },
      };
      if (data.questionnaire.isQuestionnaireForm === true) {
        setQuestionnaireCheck(true);
      } else {
        setQuestionnaireCheck(false);
      }
      let res = [];
      if (userRole === "admin" || userRole === "superAdmin") {
        res = await authorizedPost(
          `${configuration.apis.saveProfile}?editUserId=${userDetails?._id}`,
          data,
          config,
        );
      } else {
        res = await authorizedPost(
          configuration.apis.saveProfile,
          data,
          config,
        );
      }
      if (res.data.status) {
        // handleNext("next");
        const updatedProfileData = res?.data?.data;
        const profileCompletionPercentage =
          res?.data?.profileCompletionPercentage;

        if (userRole === "admin" || userRole === "superAdmin") {
          setUserDetails({
            ...userDetails,

            profile: {
              ...userDetails.profile,

              questionnaire: { ...updatedProfileData?.profile?.questionnaire },
            },
          });
        } else {
          if (updatedProfileData) {
            Object.keys(updatedProfileData).forEach((field) => {
              updateValueInLocalStorage(
                "userData",
                field,
                updatedProfileData[field],
              );
            });
          }
          if (profileCompletionPercentage) {
            updateValueInLocalStorage(
              "userData",
              "profileCompletionPercentage",
              profileCompletionPercentage,
            );
          }
        }
      } else {
        console.log("API call failed:", res.data.message);
      }
    } catch (error) {
      console.error("API call failed:", error);
    }
  };

  const fetchSingleUser = async () => {
    try {
      setLoading(true);
      const res = await authorizedGet(
        `${configuration.apis.singleUser}?userId=${location?.state?.userId}`,
        config,
      );
      const response = res?.data?.data;
      if (response) {
        setUserDetails(response);
      }
    } catch (err) {
      // Handle network or unexpected errors
      let errorMessage =
        "An unexpected error occurred. Please try again later.";

      if (err.response) {
        errorMessage =
          err.response.data.message || "Server error. Please try again.";
      } else if (err.request) {
        errorMessage = "Network error ";
      }

      errorNotify(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="font-jost mt-4 min-h-screen w-full flex-col items-center justify-center bg-bgColor pb-2 pt-20">
        <div className="mx-auto mb-14 flex w-[95%] flex-col gap-1 rounded-lg bg-bgWhite pb-3 lg:w-[98%]">
          <div className="container">
            <Step steps={steps} currentStep={currentStep} />
          </div>
          <div>
            {currentStep === 1 && (
              <BasicInformation
                currentStep={currentStep}
                setCurrentStep={setCurrentStep}
                steps={steps}
                userDetails={userDetails}
                userRole={userRole}
                setUserDetails={setUserDetails}
              />
            )}
            {currentStep === 2 && (
              <Profession
                currentStep={currentStep}
                setCurrentStep={setCurrentStep}
                steps={steps}
                userDetails={userDetails}
                userRole={userRole}
                setUserDetails={setUserDetails}
              />
            )}
            {currentStep === 3 && (
              <Religion
                currentStep={currentStep}
                setCurrentStep={setCurrentStep}
                steps={steps}
                userDetails={userDetails}
                userRole={userRole}
                setUserDetails={setUserDetails}
              />
            )}
            {currentStep === 4 && (
              <Photo
                currentStep={currentStep}
                setCurrentStep={setCurrentStep}
                steps={steps}
                userDetails={userDetails}
                userRole={userRole}
                setUserDetails={setUserDetails}
              />
            )}
            {currentStep === 5 && (
              <Expectation
                currentStep={currentStep}
                setCurrentStep={setCurrentStep}
                steps={steps}
                userDetails={userDetails}
                userRole={userRole}
                setUserDetails={setUserDetails}
              />
            )}
            {/* {currentStep === 6 && (
              <>
                {profileCompletionPercentage === 100 && !questionnaireCheck ? (
                  <UserQuestionnaire
                    currentStep={currentStep}
                    setCurrentStep={setCurrentStep}
                    steps={steps}
                    userDetails={userDetails}
                    userRole={userRole}
                    setUserDetails={setUserDetails}
                  />
                ) : (
                  <QuestionnaireForm
                    currentStep={currentStep}
                    setCurrentStep={setCurrentStep}
                    steps={steps}
                    userDetails={userDetails}
                    userRole={userRole}
                    setUserDetails={setUserDetails}
                  />
                )}
              </>
            )} */}
            {currentStep === 6 && (
              <>
                {questioonaireLink ? (
                  <UserQuestionnaire
                    currentStep={currentStep}
                    setCurrentStep={setCurrentStep}
                    steps={steps}
                    userDetails={userDetails}
                    userRole={userRole}
                    setUserDetails={setUserDetails}
                  />
                ) : (
                  <QuestionnaireForm
                    currentStep={currentStep}
                    setCurrentStep={setCurrentStep}
                    steps={steps}
                    userDetails={userDetails}
                    userRole={userRole}
                    setUserDetails={setUserDetails}
                  />
                )}
              </>
            )}

            {/* {profileCompletionPercentage < 100 &&
              questionnaireCheck === false &&
              isPopupOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
                  <div className="relative w-[90%] max-w-md rounded-lg bg-white p-6 shadow-lg">
                    <h2 className="mb-4 text-center text-lg font-semibold">
                      Select an Option
                    </h2>

                    <div className="mb-4">
                      <label className="mb-2 block cursor-pointer">
                        <input
                          type="checkbox"
                          checked={selectedOption === "file"}
                          onChange={() => setSelectedOption("file")}
                          className="mr-2"
                        />
                        Upload Questionnaire File
                      </label>
                      <label className="block cursor-pointer">
                        <input
                          type="checkbox"
                          checked={selectedOption === "form"}
                          onChange={() => setSelectedOption("form")}
                          className="mr-2"
                        />
                        Fill the Questionnaire Form
                      </label>
                    </div>

                    <div className="mt-6 flex justify-end gap-2">
                      <button
                        className="rounded bg-gray-400 px-4 py-2 text-white"
                        onClick={() => setIsPopupOpen(false)}
                      >
                        Close
                      </button>
                      <button
                        className="rounded bg-blue-600 px-4 py-2 text-white"
                        onClick={handleSubmit}
                        disabled={!selectedOption}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              )} */}
            {currentStep === 7 && (
              <Complete
                currentStep={currentStep}
                setCurrentStep={setCurrentStep}
                steps={steps}
                userDetails={userDetails}
                userRole={userRole}
              />
            )}
          </div>
        </div>
        <MessageBar />
      </div>
    </div>
  );
};

export default EditProfile;
